"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getPageViewId;

function getPageViewId() {
  var _window = window,
      nwa = _window.nwa;

  if (nwa) {
    return nwa.getGlobalProp('pageViewId');
  }

  return null;
}